const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    min_order_cost: {
      type: 'number',
      title: 'حداقل مبلغ سفارش',
    },
    min_free_ship: {
      type: 'number',
      title: 'حداقل مبلغ ارسال رایگان',
    },
    payment_type: {
      type: 'object',
      title: '',
      required: ['other', 'default'],
      properties: {
        other: {
          type: 'array',
          title: 'روش های پرداخت',
          items: [],
        },
        default: {
          type: 'string',
          title: 'روش پیشفرض',
        },
      },
    },
    send_orders_options: {
      type: 'object',
      title: 'بازه زمانی ارسال سفارشات',
      properties: {
        from_future_days: {
          type: 'number',
          title: 'از چند روز آینده',
        },
        to_future_days: {
          type: 'number',
          title: 'تا چند روز آینده',
        },
      },
    },
  },
});

export default schema;
